import { Typography, Box, Button, Alert, Grid2 as Grid } from '@mui/material';
import { FC } from 'react';
import { Add, Delete } from '@mui/icons-material';

import { JobseekerCreateDto } from '@libs/dto';
import { useForm } from '@carcareers/contexts';
import { TextInput } from '@carcareers/components';

export const ReferencesStep: FC = () => {
  const { data, setData } = useForm<JobseekerCreateDto>();
  const references = data?.references || [];

  const addReference = () => {
    const newReference = {
      name: '',
      email: '',
      phone: '',
      relationship: '',
      position: '',
    };
    setData('references', [...references, newReference]);
  };

  const removeReference = (index: number) => {
    const updatedReferences = references.filter((_, i) => i !== index);
    setData('references', updatedReferences);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant="h5" component="h2" sx={{ mb: 2, fontWeight: 600 }}>
        References
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">References</Typography>
        <Button startIcon={<Add />} onClick={addReference}>
          Add Reference
        </Button>
      </Box>

      {references.map((_, index) => (
        <Box key={index} sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 3 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="subtitle1">Reference #{index + 1}</Typography>
            <Button startIcon={<Delete />} color="error" onClick={() => removeReference(index)}>
              Remove
            </Button>
          </Box>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextInput label="Full Name" name={`references.${index}.name`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextInput label="Email" name={`references.${index}.email`} type="email" fullWidth required />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextInput label="Phone" name={`references.${index}.phone`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextInput label="Relationship" name={`references.${index}.relationship`} fullWidth required />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextInput label="Position/Title" name={`references.${index}.position`} fullWidth required />
            </Grid>
          </Grid>
        </Box>
      ))}

      {references.length === 0 && (
        <Alert severity="info">References are optional but can strengthen your application.</Alert>
      )}
    </Box>
  );
};

export default ReferencesStep;
